import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";

import { MenuEffects } from "./effects/menu.effects";
import { MenuFacade } from "./facades/menu.facade";
import * as fromMenu from "./reducers/menu.reducer";
import { MenuService } from "./services/menu.service";

@NgModule({
    imports: [
        StoreModule.forFeature(fromMenu.menuFeatureKey, fromMenu.reducer),
        EffectsModule.forFeature([MenuEffects]),
    ],
    declarations: [],
    providers: [MenuFacade, MenuService],
    exports: [],
})
export class MenuStateModule {}
